import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';

import { ROOT_URL, ROOT_API_URL, isLE } from '../../actions/root_url';
import GenericSelection from '../Common/GenericSelection';

const { Selectors } = Data;

var DropDownEditor = Editors.DropDownEditor;

export class PriceTableModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},

            selectedDay: null,
            dayOptions: [],
        }
    }

    componentDidMount() {
        // this.props.fetchPT(this.props.fjCustomerId).then((response) => {
        //     if (response.data) {
        //         this.initializeModal(response.data);
        //     }
        // }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //         alert("Server error, please refresh page. If problem persists, contact administrator.");
        //     } else {
        //         alert(JSON.stringify(err.data));
        //     }
        // });
        let temp = [];
        axios({
            method: 'GET',
            url: `${ROOT_URL}v1/dispatch/routeslist_bycustomerid/${this.props.fjCustomerId}`,
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        }).then(res => {
            if (res && res.data) {
                res.data.map((r, i) => {
                    temp.push({ label: r.Day + ' / ' + r.RouteNum, value: r.DispatchRoute_id });
                });
                this.setState({ dayOptions: temp });
            }
            // this.setState({
            //     dayOptions: [
            //         { label: <Translate value="monday" />, value: '1' },
            //         { label: <Translate value="tuesday" />, value: '2' },
            //         { label: <Translate value="wednesday" />, value: '3' },
            //         { label: <Translate value="thursday" />, value: '4' },
            //         { label: <Translate value="friday" />, value: '5' },
            //         { label: <Translate value="saturday" />, value: '6' },
            //         { label: <Translate value="sunday" />, value: '7' },
            //     ]
            // });
        }, (err) => {
            if (err.data) {
                alert(err.data);
            } else {
                alert("Server issue detected, please contact admin.");
            }
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeModal = (array) => {
        let index = 0;
        let formatter = [];
        if (array && array.length > 0) {
            array.map(r => {
                formatter.push({
                    Idx: index++, customer: r.customer, id: r.id, price: r.price, product: r.product, product_name: r.product_name,
                    product_description: r.product_description, preset_qty: r.preset_qty, is_enable: r.is_enable, routing_id: r.routing_id, ref_price: r.ref_price
                });
            })
        } else {
            formatter.push({ Idx: 0, name: "", note: "", customer: this.props.fjCustomerId });
        }
        this.setState({
            rows: formatter,
            selectedRows: [],
            editedRows: [],
        });
    }

    onSelectDay = (option) => {
        this.setState({ selectedDay: option.value });

        this.props.fetchPT(this.props.fjCustomerId, option.value, this.props.selectedWarehouse).then((response) => {
            if (response.data) {
                this.initializeModal(response.data);
            }
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            } else {
                alert(JSON.stringify(err.data));
            }
            this.setState({ rows: [] });
        });
    }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r, i) => {
            // r.recreate = false;
            if (r.is_enable === 'true') {
                this.state.rows[i].is_enable = true;
            } else if (r.is_enable === 'false') {
                this.state.rows[i].is_enable = false;
            }
        });
        this.props.updatePT(this.props.fjCustomerId, this.state.rows, this.state.selectedDay, this.props.selectedWarehouse).then((response) => {
            // alert(JSON.stringify(response.data));
            alert("Price Table Updated");
            // this.props.closePTModal();
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            } else {
                alert(JSON.stringify(err.data));
            }
        });
        // this.props.onSave(this.state.rows);
    }

    // clickNew(e) {
    //     e.preventDefault();
    //     let rows = Selectors.getRows(this.state);
    //     let index = rows.length;
    //     let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
    //     rows.push(newRow);
    //     let editedRows = [...this.state.editedRows];
    //     editedRows.push(newRow)
    //     this.setState({ rows, editedRows })
    // }

    // deleteCategory(e) {
    //     e.preventDefault();
    //     let rows = [...this.state.rows];
    //     let editedRows = [...this.state.editedRows];
    //     let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })

    //     if (this.state.selectedRows[0].id) {
    //         this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
    //             alert("Agent Deleted");
    //             rows.splice(index, 1);
    //             index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
    //             editedRows.splice(index, 1);
    //             this.setState({ rows, editedRows, selectedRows: [] })
    //             // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
    //             //     if (response.data) {
    //             //         this.initializeModal(response.data);
    //             //     }
    //             // }, (err) => {
    //             //     if (err.status === 500 || err.status === 404) {
    //             //         alert("Server error, please refresh page. If problem persists, contact administrator.");
    //             //     }
    //             // });
    //         }, (err) => {
    //             if (err.status === 500 || err.status === 404 || err.status === 405) {
    //                 alert("Error cannot delete agent.");
    //             }
    //         });
    //     }

    //     // rows.splice(index, 1);
    //     // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
    //     // editedRows.splice(index, 1);
    //     // this.setState({ rows, editedRows, selectedRows: [] })
    // }

    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }


        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }


        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const boolOptions = [
            'true',
            'false',
        ];

        let columns = [
            {
                key: 'product_name',
                name: <Translate value="service" />,
                resizable: true,
                // sortable: true,
                filterable: true,
                // editable: true,
                width: 320,
            },
            {
                key: 'price',
                name: <Translate value="price" />,
                resizable: true,
                // sortable: true,
                // filterable: true,
                editable: true,
                width: 230,
            },
        ];

        if (isLE) {
            columns = [
                {
                    key: 'product_name',
                    name: <Translate value="name" />,
                    resizable: true,
                    // sortable: true,
                    filterable: true,
                    // editable: true,
                    width: 140,
                },
                {
                    key: 'product_description',
                    name: <Translate value="description" />,
                    resizable: true,
                    // sortable: true,
                    filterable: true,
                    // editable: true,
                    width: 290,
                },
                {
                    key: 'preset_qty',
                    name: <Translate value="preset_qty" />,
                    resizable: true,
                    // sortable: true,
                    filterable: true,
                    editable: true,
                    width: 90,
                },
                {
                    key: 'price',
                    name: <Translate value="cust_price" />,
                    resizable: true,
                    // sortable: true,
                    // filterable: true,
                    editable: true,
                    width: 90,
                },
                {
                    key: 'ref_price',
                    name: <Translate value="ref_price" />,
                    resizable: true,
                    // sortable: true,
                    // filterable: true,
                    // editable: true,
                    width: 90,
                },
                {
                    key: 'is_enable',
                    name: <Translate value="enable" />,
                    resizable: true,
                    // sortable: true,
                    // filterable: true,
                    width: 120,
                    editor: <DropDownEditor options={boolOptions} />,
                    formatter: ({ value }) => (
                        <div style={{ color: (value === true || value === "true") ? "green" : "black" }}>
                            {(value === true || value === 'true') ? "true" : "false"}
                        </div>
                    ),
                },
            ];

        }

        return (
            <div className="promo-setupx">
                <div className="customer-group-selectionx">
                    <GenericSelection
                        translation={"Route:"}
                        options={this.state.dayOptions}
                        value={this.state.selectedDay}
                        setSelected={(option) => {
                            this.onSelectDay(option);
                        }}
                    />
                </div>

                <Row>
                    <Col>
                        <div style={{ maxWidth: '800px', marginLeft: '25px', marginTop: '-28px' }}>
                            <ReactDataGrid
                                toolbar={<Toolbar enableFilter />}
                                onAddFilter={handleFilterChange}
                                // rowKey="Idx"
                                enableCellSelect={true}
                                columns={columns}
                                rowGetter={rowGetter}
                                rowsCount={getSize()}
                                minHeight={400}
                                rowHeight={40}
                                headerRowHeight={45}
                                // enableRowSelect='single'
                                onRowUpdated={handleRowUpdated}
                            // rowSelection={{
                            // showCheckbox: true,
                            // onRowsSelected,
                            // onRowsDeselected,
                            // selectBy: {
                            //     isSelectedKey: 'isSelected'
                            // }
                            // }}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;

        return (
            <div>
                <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    {/* <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button> */}
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button> */}
                </ButtonToolbar>
                <Row>
                    <Col className="text-center">
                        <span>
                            {this.renderAgentTable()}
                        </span>
                    </Col>
                </Row>

                <Row className="centerStyle" style={{ marginTop: '20px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSave(e); }}
                        disabled={!this.state.selectedDay}
                    >
                        <Translate value="save" />
                    </Button>
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button> */}
                    {/* <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button> */}
                </Row>
            </div>
        );
    }
}

export default PriceTableModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/priceTableModal.jsx